export enum TokenRefreshStatus {
  refreshing = 'refreshing',
  refreshed = 'refreshed',
  initial = 'initial',
}
